export default {"src":"/_next/static/media/shopify-plus.650b6fd8.svg","height":106,"width":260,"blurWidth":0,"blurHeight":0};